import { Col, FormGroup, Label, Row } from "reactstrap";
import { UploadProjectFiles } from "../../../../utils/Constant";
import CommonFileUpload from "./CommonFileUpload";
import { useFormikContext, ErrorMessage } from "formik";
interface Heading {
  title: string;
  paragraphs: string[];
}

interface BlogInitialValue {
  title: string;
  image: File | null;
  pictureUrl?: string; // 👈 for preview
  slug: string;
  authorId: number;
  scheduledDate?: string;
  headings: Heading[];
}
const UploadProjectFile = () => {
  const { initialValues } = useFormikContext<BlogInitialValue>();
  console.log("pictureUrl", initialValues.pictureUrl);
  return (
    <Row>
      <Col>
        <FormGroup>
          <Label check>Edit Blog Image (Square Aspect Ratio)</Label>
          <CommonFileUpload
            name="image"
            existingImageUrl={initialValues.pictureUrl}
          />
          <ErrorMessage name="image" component="div" className="text-danger" />
        </FormGroup>
      </Col>
    </Row>
  );
};

export default UploadProjectFile;
